import { Button, Spinner } from "flowbite-react";
import { StyledReportPage } from "../_styles/StyledReportPage";
import { FC } from "react";
import { CondensedCodeDataGrid } from "../../components/CondensedCodeDataGrid";
import { FormStateType } from "../../enums";
import { FiltroExportarNotas } from "./components/FiltroExportarNotas";
import { useRelatorioExportarNotasPage } from "./RelatorioExportarNotasPage.hook";

export const RelatorioExportarNotasPage: FC = () => {
    const {
        loading, columns, dataSource,
        showFiltros, setShowFiltros,
        filtroCotacoes, setFiltroCotacoes, handleExportarArquivos
    } = useRelatorioExportarNotasPage();

    return (
        <StyledReportPage className="shadow rounded-md py-0.5">
            <div className="py-5">
                <h2 className="px-5 mb-4 text-lg font-semibold">Exportar Notas Fiscais Anexadas</h2>
                <hr />
            </div>

            <div className="flex gap-x-3 px-3 -mt-2 -mb-3 items-center">
                <Button
                    id="buttonGerarRelatorio"
                    size={'sm'}
                    disabled={loading}
                    onClick={() => setShowFiltros(true)}
                    color={'light'}>

                    <div className={(loading ?? false) ? "mr-3 text-white" : "text-white"}>
                        <Spinner size="sm" light={true} hidden={!loading} />
                    </div>
                    <span hidden={loading}><i className="pi pi-print text-sm mr-1.5" /> Exportar Notas</span>
                    <span hidden={!loading}>Exportando...</span>
                </Button>
            </div>

            <CondensedCodeDataGrid
                columns={columns}
                datasource={dataSource}
                sort={{
                    columnIndex: 0,
                    columnProperty: 'data',
                    direction: "desc"
                }}
                header={{ filter: false }}
                readonly={true}
                pagination={{
                    limit: 100,
                    page: 1,
                    pageCount: 1,
                    recordCount: 0
                }}
                hoverable={true}
                striped={true} />

            {showFiltros && <FiltroExportarNotas
                model={[filtroCotacoes, setFiltroCotacoes]}
                show={showFiltros}
                state={FormStateType.edit}
                saveButtonTitle="Exportar Notas"
                onClose={() => setShowFiltros(false)}
                onApplyFilter={handleExportarArquivos}
            />}

        </StyledReportPage>
    );
}